"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[358],{

/***/ 74742:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var common_1 = __webpack_require__(38971);
var AuthKitModule_1 = __webpack_require__(59443);
var ErpKitModule_1 = __webpack_require__(98378);
var UserKitModule_1 = __webpack_require__(71912);
var ApolloKitModule_1 = __webpack_require__(1291);
var CommonKitModule_1 = __webpack_require__(61582);
var LoyaltyKitModule_1 = __webpack_require__(20217);
var OrderKitModule_1 = __webpack_require__(97850);
var DeviceKitModule_1 = __webpack_require__(86857);
var DiscoveryKitModule_1 = __webpack_require__(39145);
var result_1 = __webpack_require__(97242);
var TerraKit = /** @class */ (function () {
    function TerraKit() {
        var _this = this;
        this.wrappedModule = null;
        this.getInitParams = function () { return __awaiter(_this, void 0, void 0, function () {
            var result, _a, urlParams, result_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = result_1.mapResponseToResult;
                        return [4 /*yield*/, this.wrappedModule.invoke('getInitParams')];
                    case 1:
                        result = _a.apply(void 0, [_b.sent()]);
                        if (result.isSuccess()) {
                            return [2 /*return*/, result];
                        }
                        else {
                            urlParams = new URLSearchParams(window.location.search);
                            result_2 = {};
                            urlParams.forEach(function (value, key, _) {
                                result_2[key] = value;
                            });
                            return [2 /*return*/, (0, result_1.success)(result_2)];
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * share content
         * @param content Content to share
         * @returns
         */
        this.share = function (content) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('shareContent', content); })];
            });
        }); };
        this.authKit = new AuthKitModule_1.default();
        this.erpKit = new ErpKitModule_1.default();
        this.userKit = new UserKitModule_1.default();
        this.apolloKit = new ApolloKitModule_1.default();
        this.commonKit = new CommonKitModule_1.default();
        this.loyaltyKit = new LoyaltyKitModule_1.default();
        this.orderKit = new OrderKitModule_1.default();
        this.discoveryKit = new DiscoveryKitModule_1.default();
        this.deviceKit = new DeviceKitModule_1.default();
        this.wrappedModule = new common_1.ModuleWrapper('TerraModule');
    }
    TerraKit.prototype.isAvailable = function () {
        return (__webpack_require__.g['isTerraAvailable'] && __webpack_require__.g['isTerraAvailable']()) || false;
    };
    TerraKit.prototype.finish = function () {
        this.wrappedModule.invoke('finish').then();
    };
    TerraKit.prototype.finishWithResult = function (result) {
        var _this = this;
        this.wrappedModule
            .invoke('sendFinishResult', {
            resultCode: result.resultCode,
            data: JSON.stringify(result.data),
        })
            .then(function () {
            _this.wrappedModule.invoke('finish').then();
        });
    };
    TerraKit.prototype.auth = function () {
        return this.authKit;
    };
    TerraKit.prototype.erp = function () {
        return this.erpKit;
    };
    TerraKit.prototype.user = function () {
        return this.userKit;
    };
    TerraKit.prototype.apollo = function () {
        return this.apolloKit;
    };
    TerraKit.prototype.common = function () {
        return this.commonKit;
    };
    TerraKit.prototype.loyalty = function () {
        return this.loyaltyKit;
    };
    TerraKit.prototype.order = function () {
        return this.orderKit;
    };
    TerraKit.prototype.discovery = function () {
        return this.discoveryKit;
    };
    TerraKit.prototype.device = function () {
        return this.deviceKit;
    };
    return TerraKit;
}());
exports["default"] = TerraKit;


/***/ }),

/***/ 1291:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
var common_1 = __webpack_require__(38971);
var ApolloKitModule = /** @class */ (function () {
    function ApolloKitModule() {
        var _this = this;
        this.appName = '';
        this.wrappedModule = null;
        this.getConfig = function () {
            return _this.wrappedModule.invoke('getConfig');
        };
        this.wrappedModule = new common_1.ModuleWrapper('ApolloKitModule');
    }
    return ApolloKitModule;
}());
exports["default"] = ApolloKitModule;


/***/ }),

/***/ 59443:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var common_1 = __webpack_require__(38971);
var result_1 = __webpack_require__(97242);
var AuthKitModule = /** @class */ (function () {
    function AuthKitModule() {
        this.wrappedModule = null;
        this.accessToken = null;
        this.user = null;
        this.wrappedModule = new common_1.ModuleWrapper('AuthKitModule');
    }
    AuthKitModule.prototype.isLoggedIn = function () {
        return this.user != null;
    };
    AuthKitModule.prototype.login = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('login'); })];
            });
        });
    };
    AuthKitModule.prototype.logout = function () {
        throw Error('Should not call logout within a WebView scope');
    };
    /**
     * Returns the access token of current user. Returns null if no user has logged in.
     *
     * Please call `getAccessTokenAsync` before.
     */
    AuthKitModule.prototype.getAccessToken = function () {
        return this.accessToken;
    };
    AuthKitModule.prototype.getAccessTokenAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wrappedModule.invoke('getAccessToken')];
                    case 1:
                        result = (_a.sent()).result;
                        this.accessToken = result === null || result === void 0 ? void 0 : result.accessToken;
                        return [2 /*return*/, this.accessToken];
                }
            });
        });
    };
    /**
     * Refreshes the access token. Returns an result with access token if success, otherwise returns an error result.
     */
    AuthKitModule.prototype.refreshAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, accessToken;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('refreshAccessToken'); })];
                    case 1:
                        result = _a.sent();
                        if (result.isSuccess()) {
                            accessToken = result.getValue().accessToken;
                            this.accessToken = accessToken;
                            return [2 /*return*/, (0, result_1.success)(accessToken)];
                        }
                        else {
                            return [2 /*return*/, (0, result_1.failure)(result.getError())];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns the current user. Returns null if no user has logged in.
     *
     * Please call `getFullUserInfo` before.
     */
    AuthKitModule.prototype.getUserInfo = function () {
        return this.user;
    };
    AuthKitModule.prototype.getFullUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wrappedModule.invoke('getUserInfo')];
                    case 1:
                        result = (_a.sent()).result;
                        this.user = result;
                        return [2 /*return*/, this.user];
                }
            });
        });
    };
    return AuthKitModule;
}());
exports["default"] = AuthKitModule;


/***/ }),

/***/ 61582:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ScanResultAction = exports.ScanResultCode = exports.ScanningType = void 0;
var common_1 = __webpack_require__(38971);
var dist_1 = __webpack_require__(38971);
var ScanningType;
(function (ScanningType) {
    ScanningType["PRODUCT_SERIAL"] = "serial";
    ScanningType["PRODUCT_BARCODE"] = "barcode";
    ScanningType["PRODUCT_QR"] = "qr";
    ScanningType["PRODUCT_ALL_TYPE"] = "allType";
})(ScanningType = exports.ScanningType || (exports.ScanningType = {}));
var ScanResultCode;
(function (ScanResultCode) {
    ScanResultCode[ScanResultCode["ERROR"] = 0] = "ERROR";
    ScanResultCode[ScanResultCode["SUCCESS"] = 1] = "SUCCESS";
})(ScanResultCode = exports.ScanResultCode || (exports.ScanResultCode = {}));
var ScanResultAction;
(function (ScanResultAction) {
    ScanResultAction["FORCE_CLOSE_SCAN"] = "forceCloseScan";
})(ScanResultAction = exports.ScanResultAction || (exports.ScanResultAction = {}));
// TODO: should move this module to js app because it is too specific for an application.
// TerraKit should provide a `createCustomModule(moduleName)` method in order to js can create
// your own module for specific business
var CommonKitModule = /** @class */ (function () {
    function CommonKitModule() {
        var _this = this;
        this.wrappedModule = null;
        this.deviceID = '';
        this.accessToken = null;
        this.user = null;
        this.getPrintConfig = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke('getPrintConfig'); })];
            });
        }); };
        this.printImage = function (request) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke('printImage', request); })];
            });
        }); };
        this.observeScanResult = function (request) {
            //As required by ticket MOBCOMMON-3084, need to support multiple types of ScanningType when opening screen,
            //and also ensure backward compatibility with older versions, so need to add below code to handle
            var scanningType;
            if (request.scanningTypes == null || request.scanningTypes.length != 1) {
                scanningType = ScanningType.PRODUCT_ALL_TYPE;
            }
            else {
                scanningType = request.scanningTypes[0];
            }
            var internalRequest = {
                continuous: request.continuous,
                scanningType: scanningType,
                scanningTypes: request.scanningTypes,
            };
            return _this.wrappedModule.invoke('observeScanResult', internalRequest);
        };
        this.processScanResult = function (request) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.wrappedModule.invoke('processScanResult', request).then();
                return [2 /*return*/];
            });
        }); };
        this.wrappedModule = new common_1.ModuleWrapper('CommonKitModule');
    }
    CommonKitModule.prototype.scan = function () {
        return {
            observeScanResult: this.observeScanResult,
            processScanResult: this.processScanResult,
        };
    };
    return CommonKitModule;
}());
exports["default"] = CommonKitModule;


/***/ }),

/***/ 86857:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var dist_1 = __webpack_require__(38971);
var DeviceKitModule = /** @class */ (function () {
    function DeviceKitModule() {
        this.wrappedModule = new dist_1.ModuleWrapper('DeviceKitModule');
    }
    DeviceKitModule.prototype.hasPermission = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke('hasPermission', request); })];
            });
        });
    };
    DeviceKitModule.prototype.turnOnGps = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke('turnOnGps'); })];
            });
        });
    };
    DeviceKitModule.prototype.getLocation = function (request) {
        if (request === void 0) { request = null; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke('getLocation', request); })];
            });
        });
    };
    return DeviceKitModule;
}());
exports["default"] = DeviceKitModule;


/***/ }),

/***/ 39145:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var common_1 = __webpack_require__(38971);
var DiscoveryKitModule = /** @class */ (function () {
    function DiscoveryKitModule() {
        this.wrappedModule = null;
        this.wrappedModule = new common_1.ModuleWrapper('DiscoveryKitModule');
    }
    DiscoveryKitModule.prototype.onStockRequestFinish = function (isSuccess) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wrappedModule.invoke('onStockRequestFinish', { isSuccess: isSuccess })];
                    case 1:
                        result = (_a.sent()).result;
                        return [2 /*return*/, result];
                }
            });
        });
    };
    DiscoveryKitModule.prototype.getProduct = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wrappedModule.invoke('getProduct')];
                    case 1:
                        result = (_a.sent()).result;
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return DiscoveryKitModule;
}());
exports["default"] = DiscoveryKitModule;


/***/ }),

/***/ 98378:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var common_1 = __webpack_require__(38971);
var ErpModule = /** @class */ (function () {
    function ErpModule() {
        this.terminal = null;
        this.terraConfig = null;
        this.wrappedModule = null;
        this.wrappedModule = new common_1.ModuleWrapper('ErpKitModule');
    }
    ErpModule.prototype.getSellerId = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.terminal != null)) return [3 /*break*/, 1];
                        return [2 /*return*/, (_a = this.terminal) === null || _a === void 0 ? void 0 : _a.sellerID];
                    case 1: return [4 /*yield*/, this.getTerminal()];
                    case 2:
                        result = _b.sent();
                        return [2 /*return*/, result.sellerID];
                }
            });
        });
    };
    ErpModule.prototype.getPlatformId = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.terminal != null)) return [3 /*break*/, 1];
                        return [2 /*return*/, (_a = this.terminal) === null || _a === void 0 ? void 0 : _a.platformId];
                    case 1: return [4 /*yield*/, this.getTerminal()];
                    case 2:
                        result = _b.sent();
                        return [2 /*return*/, result.platformId];
                }
            });
        });
    };
    ErpModule.prototype.getPlatformCode = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.terminal != null)) return [3 /*break*/, 1];
                        return [2 /*return*/, (_a = this.terminal) === null || _a === void 0 ? void 0 : _a.platformCode];
                    case 1: return [4 /*yield*/, this.getTerminal()];
                    case 2:
                        result = _b.sent();
                        return [2 /*return*/, result.platformCode];
                }
            });
        });
    };
    ErpModule.prototype.getTerminal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wrappedModule.invoke('getTerminal')];
                    case 1:
                        result = (_a.sent()).result;
                        this.terminal = result;
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ErpModule.prototype.getTerraConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wrappedModule.invoke('getTerraConfig')];
                    case 1:
                        result = (_a.sent()).result;
                        this.terraConfig = result;
                        return [2 /*return*/, result];
                }
            });
        });
    };
    ErpModule.prototype.getLanguage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wrappedModule.invoke('getLanguage')];
                    case 1:
                        result = (_a.sent()).result;
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return ErpModule;
}());
exports["default"] = ErpModule;


/***/ }),

/***/ 358:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var TerraKit_1 = __webpack_require__(74742);
var terraKit = new TerraKit_1.default();
__webpack_require__.g['terraKit'] = terraKit;
exports.Z = terraKit;


/***/ }),

/***/ 20217:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var common_1 = __webpack_require__(38971);
var types_1 = __webpack_require__(80900);
var LoyaltyKitModule = /** @class */ (function () {
    function LoyaltyKitModule() {
        this.wrappedModule = null;
        this.wrappedModule = new common_1.ModuleWrapper('LoyaltyKitModule');
    }
    LoyaltyKitModule.prototype.getMemberInfo = function (request) {
        if (request === void 0) { request = types_1.GetMemberInfoRequestFactory.currentUser(); }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.mapResult(function () { return _this.wrappedModule.invoke('getMemberInfo', request); })];
            });
        });
    };
    LoyaltyKitModule.prototype.openAssignMemberCard = function (memberId) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.mapResult(function () {
                        return _this.wrappedModule.invoke('openAssignMemberCard', { memberId: memberId });
                    })];
            });
        });
    };
    LoyaltyKitModule.prototype.getNetworkConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.mapResult(function () { return _this.wrappedModule.invoke('getNetworkConfig'); })];
            });
        });
    };
    LoyaltyKitModule.prototype.getLoyaltyConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.mapResult(function () { return _this.wrappedModule.invoke('getLoyaltyConfig'); })];
            });
        });
    };
    LoyaltyKitModule.prototype.mapResult = function (block) {
        return new Promise(function (resolve) {
            (0, common_1.toResult)(block).then(function (result) {
                if (result.isSuccess()) {
                    resolve(result.getValue());
                }
                else {
                    resolve({ resultCode: types_1.LoyaltyResultCode.Unexpected, message: result.getError().message });
                }
            });
        });
    };
    return LoyaltyKitModule;
}());
exports["default"] = LoyaltyKitModule;


/***/ }),

/***/ 80900:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LoyaltyResultCode = exports.GetMemberInfoRequestFactory = void 0;
exports.GetMemberInfoRequestFactory = {
    currentUser: function () {
        return {
            type: 'currentUser',
        };
    },
    phone: function (phone) {
        return {
            type: 'phone',
            phone: phone,
        };
    },
    memberQrCode: function (memberQrCode) {
        return {
            type: 'memberQrCode',
            memberQrCode: memberQrCode,
        };
    },
};
var LoyaltyResultCode;
(function (LoyaltyResultCode) {
    LoyaltyResultCode["Success"] = "Success";
    LoyaltyResultCode["Cancelled"] = "Cancelled";
    LoyaltyResultCode["CannotCallLoyaltyService"] = "CannotCallLoyaltyService";
    LoyaltyResultCode["DataInactive"] = "DataInactive";
    LoyaltyResultCode["DuplicateMemberCardId"] = "DuplicateMemberCardId";
    LoyaltyResultCode["DuplicatePhone"] = "DuplicatePhone";
    LoyaltyResultCode["InvalidParam"] = "InvalidParam";
    LoyaltyResultCode["InvalidParamFormat"] = "InvalidParamFormat";
    LoyaltyResultCode["MemberInactive"] = "MemberInactive";
    LoyaltyResultCode["MemberQrInactive"] = "MemberQrInactive";
    LoyaltyResultCode["MissingParam"] = "MissingParam";
    LoyaltyResultCode["ParamOutOfRange"] = "ParamOutOfRange";
    LoyaltyResultCode["PermissionDenied"] = "PermissionDenied";
    LoyaltyResultCode["RedemptionCodeExpired"] = "RedemptionCodeExpired";
    LoyaltyResultCode["SubjectNotFound"] = "SubjectNotFound";
    LoyaltyResultCode["SystemError"] = "SystemError";
    LoyaltyResultCode["Unauthorized"] = "Unauthorized";
    LoyaltyResultCode["Unexpected"] = "Unexpected";
    LoyaltyResultCode["MemberNotMatchMerchant"] = "MemberNotMatchMerchant";
})(LoyaltyResultCode = exports.LoyaltyResultCode || (exports.LoyaltyResultCode = {}));


/***/ }),

/***/ 97850:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var common_1 = __webpack_require__(38971);
var dist_1 = __webpack_require__(38971);
var OrderKitModule = /** @class */ (function () {
    function OrderKitModule() {
        this.wrappedModule = null;
        this.wrappedModule = new common_1.ModuleWrapper('OrderKitModule');
    }
    OrderKitModule.prototype.requestReturn = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke('requestReturn'); })];
            });
        });
    };
    OrderKitModule.prototype.navigateToCart = function (cartToken) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke('navigateToCart', { cartToken: cartToken }); })];
            });
        });
    };
    OrderKitModule.prototype.repaymentOrder = function (orderId) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke('repaymentOrder', { orderId: orderId }); })];
            });
        });
    };
    OrderKitModule.prototype.navigateToProductDetail = function (sku) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke('navigateToProductDetail', { sku: sku }); })];
            });
        });
    };
    OrderKitModule.prototype.onReturnFinish = function (reload) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke('onReturnFinish', { reload: reload }); })];
            });
        });
    };
    OrderKitModule.prototype.printReceipt = function (orderId) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke("printReceipt", { orderId: orderId }); })];
            });
        });
    };
    OrderKitModule.prototype.payForOrder = function (orderId) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke("payForOrder", { orderId: orderId }); })];
            });
        });
    };
    OrderKitModule.prototype.openOrderManagement = function (orderType) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke("openOrderManagement", orderType); })];
            });
        });
    };
    OrderKitModule.prototype.reloadOrders = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, dist_1.toResult)(function () { return _this.wrappedModule.invoke("reloadOrders", data); })];
            });
        });
    };
    return OrderKitModule;
}());
exports["default"] = OrderKitModule;


/***/ }),

/***/ 71912:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var common_1 = __webpack_require__(38971);
var UserModule = /** @class */ (function () {
    function UserModule() {
        var _this = this;
        this.wrappedModule = null;
        /**
         * Get profile of user currently login to the App
         * @returns
         */
        this.getUserProfile = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('getUserProfile'); })];
            });
        }); };
        /**
         * Update info of an user
         * @param request profile of the user currently login to the App
         * @returns
         */
        this.updateUserProfile = function (profile) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('updateUserProfile', profile); })];
            });
        }); };
        /**
         * Lookup customer based on keyword.
         * @param request
         * @returns
         */
        this.searchProfile = function (request) {
            return (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('searchProfile', request); });
        };
        /**
         * Update info of customer.
         * @param request
         * @returns
         */
        this.upsertProfile = function (profile) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('upsertProfile', profile); })];
            });
        }); };
        this.registerProfile = function (request) {
            return (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('registerProfile', request); });
        };
        this.createNewAddress = function (request) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('createNewAddress', request); })];
            });
        }); };
        this.updateAddress = function (request) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('updateAddress', request); })];
            });
        }); };
        this.deleteAddress = function (request) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('deleteAddress', request); })];
            });
        }); };
        /**
         * Get appFlow of the current login user
         * @returns
         */
        this.getOperationFlowConfig = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('getOperationFlowConfig'); })];
            });
        }); };
        this.changeDealer = function (request) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('changeDealer', request); })];
            });
        }); };
        this.fetchUserAddressList = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('fetchUserAddress'); })];
            });
        }); };
        this.getDetailProfile = function (request) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('getDetailProfile', request); })];
            });
        }); };
        this.publishCustomer = function (customer) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('publishCustomer', customer); })];
            });
        }); };
        this.fetchCustomerTypes = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, common_1.toResult)(function () { return _this.wrappedModule.invoke('fetchCustomerTypes'); })];
            });
        }); };
        this.wrappedModule = new common_1.ModuleWrapper('UserKitModule');
    }
    return UserModule;
}());
exports["default"] = UserModule;


/***/ })

}]);